"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeclarationType = void 0;
var DeclarationType;
(function (DeclarationType) {
    DeclarationType["BANKRUPT"] = "92";
    DeclarationType["FORECLOSED"] = "93";
    DeclarationType["OBLIGATED_ALIMONY_CHILDSUPPORT"] = "97";
    DeclarationType["BORROWED_DOWN_PAYMENT"] = "98";
})(DeclarationType = exports.DeclarationType || (exports.DeclarationType = {}));
